<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.isXg' clearable
                                                      :placeholder="$t('港澳') " style='width:120px'>
              <Option :value="'0'" :key='0'>{{ $t('新澳门') }}</Option>
              <Option :value="'1'" :key='1'>{{ $t('香港') }}</Option>
              <Option :value="'2'" :key='2'>{{ $t('老澳门') }}</Option>
              <Option :value="'3'" :key='3'>{{ $t('新加坡') }}</Option>
              <Option :value="'4'" :key='4'>{{ $t('柬埔寨') }}</Option>
              <Option :value="'5'" :key='5'>{{ $t('台湾') }}</Option>
              <Option :value="'6'" :key='6'>{{ $t('印尼') }}</Option>
              <Option :value="'7'" :key='7'>{{ $t('马来西亚') }}</Option>
            </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.title' :placeholder="$t('标题') "></Input>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary'  @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
            <Button type='info'  @click='inAll' icon='md-add'>{{
                $t('批量新增')
              }}
            </Button>
            <Button type='error'  @click='outAll' icon='md-add'>{{
                $t('批量导出')
              }}
            </Button>

          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label='标题' prop='title'>
          <Input clearable v-model='windowAddItem.title' :placeholder="$t('请输入标题名称')"></Input>
        </FormItem>
        <FormItem label='港澳' prop='isXg'>
          <Select clearable v-model='windowAddItem.isXg' style='width:200px'>
            <Option :value="0" :key='0'>{{ $t('新澳门') }}</Option>
            <Option :value="1" :key='1'>{{ $t('香港') }}</Option>
            <Option :value="2" :key='2'>{{ $t('老澳门') }}</Option>
            <Option :value="3" :key='3'>{{ $t('新加坡') }}</Option>
            <Option :value="4" :key='4'>{{ $t('柬埔寨') }}</Option>
            <Option :value="5" :key='5'>{{ $t('台湾') }}</Option>
            <Option :value="6" :key='6'>{{ $t('印尼') }}</Option>
            <Option :value="7" :key='7'>{{ $t('马来西亚') }}</Option>
          </Select>
        </FormItem>
        <span>$issue可代替期号<br></span>
        <FormItem label='图片地址(链接)' prop='content'>
          <Input  clearable v-model='windowAddItem.content' :placeholder="$t('请输入图片的链接地址')"></Input>
        </FormItem>

        <FormItem label="图片地址(本地上传)" prop="content">
          <div class="demo-upload-list" v-if="windowAddItem.content">
            <img :src="windowAddItem.content" style="max-width: 200px;max-height: 200px">
            <div class="demo-upload-list-cover">
              <Icon type="ios-trash-outline" @click.native="handleImgRemove('content')"></Icon>
            </div>
          </div>
          <input v-if="windowAddItem.content" v-model="windowAddItem.content" type="hidden" name="image">
          <Upload type="drag" :action="uploadUrl" :headers="uploadHeader" v-if="!windowAddItem.content"
                  :format="['jpg','jpeg','png','gif']" :max-size="5120" :on-success="v=>{handleImgSuccess(v,'content')}"
                  :on-format-error="handleImgFormatError" :on-exceeded-size="handleImgMaxSize"
                  style="display: inline-block;width:58px">
            <div style="width: 58px;height:58px;line-height: 58px">
              <Icon type="md-camera" size="20"></Icon>
            </div>
          </Upload>

        </FormItem>

      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->

    <!-- windowAddEdit -->
    <Modal v-model="windowPL.show" width="728" :styles="{top: '30px'}" @on-visible-change="windowPLCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('编辑')  }}</span>
      </p>
      <Form ref="windowPLForm" :model="windowPLItem" :label-width="80"
            label-position="left">
        <FormItem label='内容(新增时请参考批量导出的格式)' prop='content'>
          <textarea v-model="windowPLItem.content"  rows="10" cols="80"></textarea>
        </FormItem>

      </Form>
      <div slot="footer" >
        <Button type="text" @click="windowPLCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button v-if="!windowPL.isOut" type="primary" @click="windowPLSubmit" :loading="windowPL.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->



  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'
import {
  baseUrl
} from '@/libs/api.request'
import {
  getToken
} from '@/libs/util'
export default {
  name: 'interface_list',
  data() {
    return {
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: {
        'Authorization': "bearer " + getToken()
      },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [ {
        title: '序号',
        type: 'index',
        width: 65,
        align: 'center'
      },{
        title: this.$t('标题'),
        key: 'title',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('港澳'),
        align: 'center',
        width: 50,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.isXg != 0 ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.isXg != 0 ? '1px solid #ed4014' : '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, this.getGameName(params.row.isXg)),
          ])
        }
      },{
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                Object.assign(vm.windowAddItem, params
                  .row) //浅复制数据params.row 给 vm.windowAddItem
                vm.windowAdd.show = true
              }
            }
          }, this.$t('编辑')),h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                customPost('Lhc/tukuDataDel', {id:params.row.id}).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ])])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        content:''
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
      //弹窗--------------
      windowPL: { //弹窗
        show: false,
        loading: false,
        index: 0,
        isOut:false
      },

      windowPLItem: { //弹窗数据绑定
        id: 0
      },
      windowPLValidate: {//窗口校验规则
      },                            //----------------

    }
  },
  created() {
    let vm = this
    vm.getList()
  },
  mounted() {
    this.getParams()
  },
  methods: {
    getGameName(isXg){
      if(isXg==0){
        return "新澳门";
      }else  if(isXg==1){
        return "香港";
      }else  if(isXg==2){
        return "老澳门";
      }else  if(isXg==3){
        return "新加坡";
      }else  if(isXg==4){
        return "柬埔寨";
      }else  if(isXg==5){
        return "台湾";
      }else  if(isXg==6){
        return "印尼";
      }else  if(isXg==7){
        return "马来西亚";
      }
      return ""
    },
    inAll() {
      let vm = this
      vm.windowPL.isOut=false
      vm.windowAddItem.content='';
      vm.windowPL.show = true


    },
    outAll() {
      let vm = this
      vm.windowPL.isOut=true
      customPost('Lhc/tukuInOrOut', {}).then(response => {
        vm.windowPLItem=response.data.data
        vm.windowPL.show = true
      })
    },
    preAdd() {
      let vm = this
      vm.windowAddItem.id=0;
      vm.windowAddItem.title='';
      vm.windowAddItem.tip='';
      vm.windowAddItem.content='';
      vm.windowAdd.show = true
    },
    getParams() {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page= vm.tableShow.currentPage
      vm.searchConf.size= vm.tableShow.pageSize
      customPost('Lhc/tukuDataGetList',vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          customPost('Lhc/tukuUpdateOrCreate',vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  handleImgFormatError(file) {
    this.$Notice.warning({
      title: '文件类型不合法',
      desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
    })
  },
  handleImgRemove(key) {
    this.windowAddItem[key] = ''
  },
  handleImgSuccess(response,key) {
    if (response.code === 1) {
      this.$Message.success(response.msg)
      if (response.data.fileUrl.startsWith('http')) {
        this.windowAddItem[key] = response.data.fileUrl
      } else {
        console.log(response.data.showUrl)
        this.windowAddItem[key] = response.data.showUrl
      }
    } else {
      this.$Message.error(response.msg)
    }
  },
  handleImgMaxSize(file) {
    this.$Notice.warning({
      title: '文件大小不合法',
      desc: file.name + '太大啦请上传小于5M的文件。'
    })
  },
    windowPLCancel(data) {
      if (!data) {
        this.windowPLItem.id = 0
        this.$refs['windowPLForm'].resetFields()
        this.windowPL.show = false
        this.windowPL.loading = false
        this.windowPL.index = 0
      }
    }, windowPLSubmit() {
      let vm = this
      vm.$refs['windowPLForm'].validate((valid) => {
        if (valid) {
          vm.windowPL.loading = true
          vm.windowPLItem.isIn=1
          customPost('Lhc/tukuInOrOut', vm.windowPLItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowPLCancel()
          })

        }
      })
    },
  }
}
</script>
